// Layout: Home page
// 

JLM.MD.PageHome = function( container ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Properties: Private ______________________________________________________
	
	// Settings
	let section_index = 0,
		transitioning = false;
	
	// References
	let section_page, sections, scrollbar;
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// References
		section_page = $('section.page', container);
		sections = $('section', section_page);
		scrollbar = new JLM.MD.Scrollbar( $('.scrollbar', container) );
		
		// Observed elements
		let observed_elements = [];
		$('.layer_photos .col figure', sections).each(function() {
			observed_elements.push( $(this) );
		});
		$('.layer_headline .col h1', sections).each(function() {
			observed_elements.push( $(this) );
		});
		$('.layer_text .col h2', sections).each(function() {
			observed_elements.push( $(this) );
		});
		$('.layer_text .col nav', sections).each(function() {
			observed_elements.push( $(this) );
		});
		
		// Observer
		if ( window.IntersectionObserver ) {
			var observer_scroll = new IntersectionObserver(function(entries, observer) {
				entries.forEach(function(entry) {
					if ( entry.isIntersecting ) {
						$(entry.target).addClass('reveal');
						observer_scroll.unobserve(entry.target);
					}
				});
			}, {
				root: null,
				rootMargin: '0px',
				threshold: 0
			});
			observed_elements.forEach(function(element) {
				observer_scroll.observe(element[0]);
			});
		} else {
			observed_elements.forEach(function(element) {
				element.addClass('reveal');
			});
		}
		
		// Events
		$('.layer_text .col .signal', sections).on('click', function() {
			requestSectionMove(1);
		});
		scrollbar.on('dragging', function(position, percent) {
			if ( percent < 0.3333 && section_index !== 0 ) {
				moveToSection(0);
			} else if ( percent >= 0.3333 && percent < 0.6666 && section_index !== 1 ) {
				moveToSection(1);
			} else if ( percent >= 0.6666 && section_index !== 2 ) {
				moveToSection(2);
			}
		});
		$(window).on('keydown', function(event) {
			if ( event.originalEvent.key === 'ArrowDown' ) {
				requestSectionMove(1);
			} else if ( event.originalEvent.key === 'ArrowUp' ) {
				requestSectionMove(-1);
			}
		});
		$('body').on('mousewheel DOMMouseScroll wheel', function(event) {
			if ( Math.abs(event.originalEvent.deltaY) >= 3 ) {
				requestSectionMove( event.originalEvent.deltaY > 0 ? 1 : -1 );
			}
		});
		
		// Load talent photos
		$('.layer_photos figure').each(function() {
			let talent_image = $(this).attr('data-image');
			const figure = $(this),
				  image = $('<div class="image" />').css({ backgroundImage: 'url(' + talent_image + ')' });
			loadImage(talent_image, function() {
				figure.append(image).addClass('loaded');
			});
		});
		
		// Display content
		setTimeout(function() {
			sections.eq(section_index).addClass('focus').removeClass('off_below').removeClass('off_above');
		}, 25);
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Checks conditions before updating section
	// 
	function requestSectionMove(direction) {
		if ( !transitioning ) {
			let section_index_new = section_index + direction;
			if ( section_index_new >= 0 && section_index_new <= (sections.length - 1) ) {
				moveToSection(section_index_new);
			}
		}
	}
	
	
	// Change sections
	// 
	function moveToSection(index) {
		// Update page
		section_page.attr('data-section', index);
		sections.each(function(i) {
			if (i === index) {
				$(this).addClass('focus').removeClass('off_below').removeClass('off_above');
			} else {
				let class_off = ( i > index ? 'off_below' : 'off_above' );
				$(this).addClass(class_off).removeClass('focus');
			}
		});
		
		// Update scrollbar
		scrollbar.setPercent(index / (sections.length - 1));
		
		// Remember change
		section_index = index;
		
		// Set state
		transitioning = true;
		setTimeout(function() {
			transitioning = false;
		}, 1200);
	}
	
	
	// Check if section is in view
	// 
	function isSectionOnScreen(entries, observer) {
		entries.forEach(function( entry ) {
			const target = $(entry.target);
			let is_focus = false;
			if (entry.intersectionRatio >= SCROLL_THRESHOLD) {
				target.addClass('focus').removeClass('off_below').removeClass('off_above');
				is_focus = true;
			} else {
				let class_off = ( entry.boundingClientRect.top > 0 ? 'off_below' : 'off_above' );
				target.addClass(class_off).removeClass('focus');
			}
		});
	}
	
	
	// Load an image to memory
	// 
	function loadImage(image_src, callback) {
		const image_mem = new Image();
		image_mem.onload = function() {
			setTimeout(callback, 50);
		};
		image_mem.onerror = function() {};
		image_mem.src = image_src;
	}
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};